import { FC, useCallback } from "react";
import { IColumn, IconButton } from "@fluentui/react";
import { TextField, useTheme } from "cayo.ui";
import { OnColumnFilterChange } from "@cayo/shared/components/GridContainer/types/columnFilters";
import {
  clearButtonStyles,
  ClearButtonWrap,
  columnFilterFieldStyles,
  FieldWrap,
} from "./ColumnFilterField.styles";

interface ColumnFilterFieldProps {
  column: IColumn;
  value: string;
  onColumnFilterChange: OnColumnFilterChange;
}

export const ColumnFilterField: FC<ColumnFilterFieldProps> = ({
  column,
  value,
  onColumnFilterChange,
}) => {
  const theme = useTheme();

  const fieldName = column.fieldName ?? column.key;
  const label = column.name ?? fieldName;

  const handleChange = useCallback(
    (newValue: string) => {
      onColumnFilterChange(fieldName, newValue ?? "");
    },
    [fieldName, onColumnFilterChange]
  );

  const handleClear = useCallback(() => {
    onColumnFilterChange(fieldName, "");
  }, [fieldName, onColumnFilterChange]);

  return (
    <FieldWrap>
      <TextField
        type="text"
        ariaLabel={`Filter ${label}`}
        value={value}
        setValue={handleChange}
        autocomplete="off"
        styles={columnFilterFieldStyles(theme)}
      />
      {value && (
        <ClearButtonWrap>
          <IconButton
            iconProps={{ iconName: "Clear" }}
            ariaLabel={`Clear filter ${label}`}
            title={`Clear filter ${label}`}
            styles={clearButtonStyles()}
            onClick={handleClear}
          />
        </ClearButtonWrap>
      )}
    </FieldWrap>
  );
};
